import OnboardRoutes from "./onboard-route";
import AuthRoutes from "./auth-route";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const Navigation = () => {
	const isAuthorized = useSelector((state) => state.users.token);
	const isMembership = useSelector((state) => state.users.user?.is_membership);
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const storedPath = localStorage.getItem("currentPath");
		if (storedPath && storedPath !== location.pathname) {
			navigate(storedPath);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem("currentPath", location.pathname);
	}, [location.pathname]);

	return <>{isAuthorized ? <AuthRoutes /> : <OnboardRoutes />}</>;
};

export default Navigation;
